import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

// Components
import Text from '../Text'
import ErrorHeadline from './ErrorHeadline'

const AddressAlreadyExists = ({ firstName }) => (
  <>
    <ErrorHeadline>
      <FormattedMessage
        id='Error.addressAlreadyExists.headline'
        defaultMessage='Hmmm... looks like someone already has a Homebot for this home address.'
      />
    </ErrorHeadline>
    <Text variant='neutralCool' variantCount='700' size='s' paragraph>
      <FormattedMessage
        id='Error.addressAlreadyExists.message'
        defaultMessage='Contact {firstName} for more info or to try again.'
        values={{
          firstName,
        }}
      />
    </Text>
  </>
)

AddressAlreadyExists.propTypes = {
  firstName: PropTypes.string,
}

export default AddressAlreadyExists
